import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiBarChart2 } from 'react-icons/fi';

// Persistent sitewide chrome: an ALWAYS-VISIBLE educational banner (legal
// posture — see CLAUDE.md), the top nav, and the disclaimer footer. Every page
// renders inside this so the "educational only / not advice" framing can never
// be missed on any route.
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="app-shell">
      {/* Educational banner — sticky, on every page, not dismissible. */}
      <div className="edu-banner" role="note">
        📚 <strong>For educational purposes only.</strong> We are educators — not
        financial, investment, or trading advisers. Nothing here is a recommendation
        to buy or sell.
      </div>

      <header className="topbar">
        <div className="topbar-inner">
          <Link to="/" className="brand" aria-label="CCFOS home">
            <FiBarChart2 className="brand-icon" />
            <span className="brand-name">CCFOS</span>
          </Link>
          <nav className="topnav">
            <NavLink to="/" end className={navClass}>Home</NavLink>
            <NavLink to="/charts" className={navClass}>Charts</NavLink>
            <NavLink to="/learn" className={navClass}>Learn</NavLink>
          </nav>
        </div>
      </header>

      <main className="page">{children}</main>

      <footer className="footer">
        <div className="footer-inner">
          <p className="footer-tag">
            <strong>CCFOS</strong> · Currency · Commodities · Crypto · Futures · Options · Stocks
          </p>
          <p className="footer-disclaimer">
            <strong>Educational content only.</strong> CCFOS provides charting tools and
            teaching material about markets. It does not provide financial, investment,
            tax, or trading advice, and nothing here is a recommendation or solicitation
            to buy or sell any security or instrument. Trading and investing carry risk,
            including loss of capital. You are solely responsible for your own decisions.
            Past or hypothetical performance is not indicative of future results.
          </p>
          <p className="footer-copy">© {'2026'} CCFOS. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

const navClass = ({ isActive }: { isActive: boolean }) =>
  'topnav-link' + (isActive ? ' active' : '');

export default Layout;
